import { APIS, URLS } from '@/shared/config/urls';
import type { ApiResponse } from '@/shared/types/abstract-api-response';
import type {
  POSTSiteModel,
  PUTSiteModel,
  Site,
  SiteData,
} from '@/shared/types/types-site-management';
import { request } from '@/shared/utils/request';

// [GET] Site List
export const fetchSiteList: (params: string) => Promise<ApiResponse<Site[]>> = async (
  params = ''
) => {
  const url = `${URLS.BACK_DSH}${APIS.siteList(params)}`;
  return await request.get(url);
};

// [GET] Detail Site Info
export const fetchDetailSite: (siteId: number) => Promise<ApiResponse<SiteData>> = async (
  siteId
) => {
  const url = `${URLS.BACK_DSH}${APIS.detailSite(String(siteId))}`;
  return await request.get(url);
};

// [DELETE] Delete Site
export const deleteSite: (siteData: number) => Promise<ApiResponse<{ site_id: number }>> = async (
  siteId
) => {
  const url = `${URLS.BACK_DSH}${APIS.deleteSite(siteId)}`;
  return await request.delete(url);
};

// [PUT] Update Site
export const updateSite: (siteData: PUTSiteModel) => Promise<ApiResponse<{ site_id: number }>> =
  async (siteData) => {
    const { site_id, ...body } = siteData;
    const url = `${URLS.BACK_DSH}${APIS.updateSite(site_id)}`;
    return await request.put(url, body);
  };

// [POST] Create Site
export const createSite: (siteData: POSTSiteModel) => Promise<ApiResponse<{ site_id: number }>> =
  async (siteData) => {
    const url = `${URLS.BACK_DSH}${APIS.createSite}`;
    return await request.post(url, siteData);
  };
